import {
  MIN_DISTANCE_DEVIATION,
  MAX_DISTANCE_DEVIATION
} from '#component/shipment/form/delivery/distance-deviation';
import { convertDistance } from '#helper';

const MAX_MINUTES = 24 * 60;

export default (values, { measurementSystem }) => {
  const isMetric = measurementSystem === 'metric';
  const minRadius = convertDistance(MIN_DISTANCE_DEVIATION, 'metric', measurementSystem);
  const maxRadius = convertDistance(MAX_DISTANCE_DEVIATION, 'metric', measurementSystem);
  const distanceUnit = isMetric ? 'meters' : 'miles';
  const errors = {
    address: {}
  };

  if (!values.companyName && !values.firstName && !values.lastName) {
    errors.companyName = 'Required';
    errors.firstName = 'Required';
    errors.lastName = 'Required';
  }

  if (values.firstName && values.firstName.length < 2) {
    errors.firstName = 'Min 2 characters';
  } else if (values.firstName?.length > 128) {
    errors.firstName = 'Max 128 characters';
  }

  if (values.email && (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,62}$/i.test(values.email))) {
    errors.email = 'Invalid email address';
  }

  if (values.lastName && values.lastName.length < 2) {
    errors.lastName = 'Min 2 characters';
  } else if (values.lastName?.length > 128) {
    errors.lastName = 'Max 128 characters';
  }

  if (values.companyName && values.companyName.length < 2) {
    errors.companyName = 'Min 2 characters';
  } else if (values.companyName?.length > 255) {
    errors.companyName = 'Max 255 characters';
  }

  if (Object.values(values.address ?? {}).every(v => !v)) {
    errors.address.address1 = 'Required';
    errors.formattedAddress = 'Required';
  }

  if (values.address?.address1?.length > 128) {
    errors.address.address1 = 'Max 128 characters';
  }

  if (values.address?.address2?.length > 128) {
    errors.address.address2 = 'Max 128 characters';
  }

  if (values.address?.city?.length > 128) {
    errors.address.city = 'Max 128 characters';
  }

  if (values.address?.state?.length > 128) {
    errors.address.state = 'Max 128 characters';
  }

  if (values.address?.country?.length > 128) {
    errors.address.country = 'Max 128 characters';
  }

  if (values.address?.zipCode?.length > 16) {
    errors.address.zipCode = 'Max 16 characters';
  }

  if (!values.radius) {
    errors.radius = 'Required';
  } else if (Number.isNaN(+values.radius)) {
    errors.radius = 'Number value required';
  } else if (+values.radius < minRadius) {
    errors.radius = { _error: `Minimum ${minRadius} ${distanceUnit}` };
  } else if (+values.radius > maxRadius) {
    errors.radius = { _error: `Maximum ${maxRadius} ${distanceUnit}` };
  }

  if (!values.minutes) {
    errors.minutes = 'Required';
  } else if (Number.isNaN(+values.minutes)) {
    errors.minutes = 'Number value required';
  } else if (+values.minutes < 1) {
    errors.minutes = { _error: 'Minimum 1 minute' };
  } else if (+values.minutes > MAX_MINUTES) {
    errors.minutes = { _error: 'Maximum 24 hours (1440 minutes)' };
  } else if (!(values.minutes.indexOf('.') === -1)) {
    errors.minutes = { _error: 'Only integers allowed' };
  }

  if (!values?.addressbook?.id) {
    errors.addressbook = 'Required';
  }

  return errors;
};
